import { getItemMaker } from "./tools";

const i = getItemMaker("helmets");
export const helmets = [
  i("Grey Beret"),
  i("Traffic Cone", "EquipmentHats12"),
  i("Propeller Cap"),
  i("Baseball Hat"),
  i("Farmer Brim"),
  i("Leather Cap"),
  i("Copper Helmet", "EquipmentHats17"),
  i("Militia Helm", "EquipmentHats20"),
  i("Thief Hood", "EquipmentHats3"),
  i("Top Hat", "EquipmentHats16"),
  i("Birthday Hat", "EquipmentHats21"),
  i("Iron Helmet", "EquipmentHats18"),
  i("Amarok Helmet", "EquipmentHats22"),
  i("Gold Helmet", "EquipmentHats28"),
  i("Platinum Helmet", "EquipmentHats19"),
  i("Viking Cap", "TestObj13"),
  i("Sleek Coif", "EquipmentHats41"),
  i("Witch Hat", "EquipmentHats26"),
  i("Efaunt Helmet"),
  i("Dementia Helmet", "EquipmentHats53"),
  i("Void Imperium Helmet", "EquipmentHats54"),
  i("Mark of Member"),
  i("Murmillo Helm"),
  i("Conquistador Plume", "EquipmentHats59"),
  i("Adornment of the High Priest"),
  i("Chizoar Helmet"),
  i("Lustre Veil"),
  i("Diabolical Headcase"),
  i("Thin Veil of The Troll", "EquipmentHats74"),
  i("Magma Core Headdress"),
  i("Skulled Helmet of the Divine"),
  i("Marbiglass Headdress"),
  i("Crown of the Gods"),
  i("White Headband", "EquipmentHats5"),
  i("Green Headband", "EquipmentHats6"),
  i("Red Headband"),
  i("Purple Tupacband"),
  i("Yellow Headband", "EquipmentHats9"),
  i("Pink Headband"),
  i("Stump Prop", "EquipmentHats4Choppin"),
  i("Bored Beanie", "EquipmentHats25"),
  i("Shiny Bored Beanie"),
  i("Alien Headband", "EquipmentHats29"),
  i("Grandma Disguise", "EquipmentHats39"),
  i("Paper Boat", "EquipmentHats27"),
  i("Cowbo Galloneer", "EquipmentHats30"),
  i("Jar", "EquipmentHats44"),
  i("Royal Turban", "EquipmentHats2"),
  i("Acorn Topper", "EquipmentHats67"),
  i("Nuget Cake Fedora"),
  i("Honker Hat"),
  i("Real Civil Engineer Helmet"),
  i("The Crow Perch"),

  i("Ice Guard Helmet", "EquipmentHats79"),
  i("Big Pretty Bow", "EquipmentHats51"),
  i("Bunny Ears"),
  i("Summer Shell"),
  i("Santa Hat"),
  i("3rd Anniversary Ice Cream Topper"),
  i("Steam Cap"),
  i("Apple Launch Hat"),
  i("Funny Hat"),
  i("Meteorhead"),
  i("Epic Santa Hat", "EquipmentHats111"),
  i("Pink Beanie", "EquipmentHats113"),
];
